export const QueuePager = ({ shown, total, hasMore, loading, onMore, testid }) => {
  if (!total) return null;
  return (
    <div className="flex items-center justify-between text-xs text-slate-500 px-1" data-testid={testid}>
      <span data-testid={`${testid}-count`}>Showing {shown} of {total}{hasMore ? " — more records exist" : ""}</span>
      {hasMore && (
        <button onClick={onMore} disabled={loading} data-testid={`${testid}-load-more`}
          className="h-8 px-3 rounded-md border border-slate-200 text-slate-700 hover:bg-slate-50 disabled:opacity-50">
          {loading ? "Loading…" : "Load more"}
        </button>
      )}
    </div>
  );
};
